<template>
    <video
        v-if="src.endsWith('.mp4')"
        :src="src"
        :alt="alt"
        controls></video>
    <figure
        v-else
        :class="['object-' + objectCover, {'has-radius': borderRadius, 'has-ratio': aspectRatio}]"
        :style="{ paddingTop: aspectRatio * 100 + '%' }">
        <img
            :src="src"
            :alt="alt"
            :data-action="zoom ? 'zoom' : false">
    </figure>
</template>

<script>
import 'zoom-vanilla.js/dist/zoom.css'
import 'zoom-vanilla.js/dist/zoom-vanilla.min.js'

    export default {
        name: 'CoreImage',
        props: {
            src: {
                type: String,
                default: ''
            },
            alt: {
                type: String,
                default: ''
            },
            objectCover: {
                type: String,
                default: 'cover'
            },
            borderRadius: {
                type: Boolean,
                default: false
            },
            aspectRatio: {
                type: Number,
                default: undefined
            },
            zoom: {
                type: Boolean,
                default: false
            }
        }
    }
</script>

<style lang="scss" scoped>
video {
    max-width: 100%;
}
figure {
    display: block;
    position: relative;
    width: 100%;

    &.has-radius {
        display: flex;
        position: relative;
        overflow: hidden;
        border-radius: 4px;
    }

    &.has-ratio {
        img {
            position: absolute;
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;
        }
    }
}
</style>
